import React, { useState, useRef } from "react";
import IconHt from "../../images/icon-partner-harristeeter.svg";
import IconKroger from "../../images/icon-partner-kroger.svg";
import IconDassault from "../../images/icon-partner-dassault.svg";
import IconFlexprint from "../../images/icon-partner-flexprint.svg";
import IconSalesmate from "../../images/icon-partner-salesmate.svg";
import IconBigCommerce from "../../images/icon-partner-bigcommerce.svg";
import IconTresata from "../../images/icon-partner-tresata.svg";
import IconCb from "../../images/icon-partner-cb.svg";
import IconMinterapp from "../../images/icon-partner-minterapp.svg";
import { motion, useViewportScroll, useTransform, useSpring } from 'framer-motion';
import InView from 'react-intersection-observer';
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";
import LazyLoad from 'react-lazyload';

export default function HomePartner() {
  const [isVisible, setIsVisible] = useState(false);
  const easing = [0.42, 0, 0.58, 1];
  const [elementTop, setElementTop] = useState([0, 0]);
  const [clientHeight, setClientHeight] = useState(0);
  const [isMobile, setisMobile] = useState(false);
  const ref = useRef();
  const { scrollY } = useViewportScroll();

  const setValues = () => {
    setisMobile(window.innerWidth <= 767);
    if (!ref.current) return;
    setElementTop([ref.current.offsetTop]);
    setClientHeight(window.innerHeight);
  };

  let scale = useSpring(useTransform(scrollY, [elementTop[0] - clientHeight, elementTop[0] - clientHeight / 3], [0.3, 1], easing),
    {
      damping: 50,
      stiffness: 500
    });
  if (!elementTop[0])
    scale = 1;
  const items = [
    {
      count: "12+",
      time: "Years"
    }, {
      count: "430+",
      time: "Clients"
    }, {
      count: "250+",
      time: <>Talented <br /> Employees</>
    }, {
      count: 210,
      time: <>Products <br /> Launched</>
    }, {
      count: 3,
      time: <>Products <br /> Owned</>
    }, {
      count: "70MM+",
      time: <>Lives touched daily</>
    },
  ];

  const logos = [
    {
      logo: IconHt,
      title: "Harris Teeter",
      alt: "harris teeter"
    }, {
      logo: IconKroger,
      title: "Kroger",
      alt: "kroger"
    }, {
      logo: IconDassault,
      title: "Dassault Systemes",
      alt: "dassault systemes"
    }, {
      logo: IconFlexprint,
      title: "Flexprint",
      alt: "flexprint"
    }, {
      logo: IconBigCommerce,
      title: "BigCommerce",
      alt: "bigCommerce"
    }, {
      logo: IconTresata,
      title: "Tresata",
      alt: "tresata"
    }, {
      logo: IconSalesmate,
      title: "Salesmate",
      alt: "salesmate"
    }, {
      logo: IconCb,
      title: "The Cook & Boardman Group",
      alt: "the cook & boardman group"
    }, {
      logo: IconMinterapp,
      title: "Minterapp",
      alt: "minterapp"
    },
  ];

  const triggers = [[1, 0.9], [0.95, 0.85], [0.9, 0.8], [1, 0.9], [0.95, 0.85], [0.9, 0.8], [1, 0.9], [0.95, 0.85], [0.9, 0.8],];
  return (
    <div className="about-partner-section section-gap" id="about-partner-section" onLoad={setValues}>
      <InView onChange={(inView) => setIsVisible(inView)} threshold={[0.05]}>
        <div className="container">
          <div className="about-page-into-section">
            <p className="theme-color-title">{isVisible && <HeaderAnim header="about rapidops" />}</p>
            <h2 className="secondary-font">Who we are</h2>
            <p className="content">Since 2008, we assist everyone from Fortune 500 companies to innovative startups to build and transform their businesses using the most advanced technology, data and design.</p>
          </div>

          <div ref={ref} className="about-counter-section">
            <ul className="about-counter">
              {items.map((item, i) => {
                return <li className="counter-item" key={i}>
                  {!isMobile ?
                    <motion.div style={{ scale }} className="counter-item-inner">
                      <span className="count-number">{item.count}</span>
                      <span className="counter-text">{item.time}</span>
                    </motion.div> :
                    <div className="counter-item-inner">
                      <span className="count-number">{item.count}</span>
                      <span className="counter-text">{item.time}</span>
                    </div>}
                </li>;
              })
              }
            </ul>
          </div>

          <div className="partner-logo-block">
            <ul className="row partner-logo-list d-flex flex-wrap">
              {
                logos.map((logo, i) => {
                  return <Parallax key={i} id={"partner-logo-list-" + i} direction={directions.LTR} length={50} opacity={true} triggers={triggers[i]}>
                    <motion.li className="col">
                      <LazyLoad key={i}>
                        <img src={logo.logo} title={logo.title} alt={logo.alt} />
                      </LazyLoad>
                    </motion.li>
                  </Parallax>;

                  //return <SlideInWithScroll elementTop={elementTop[1]} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[i], triggers[i + 1]]} key={i} direction="BTT" />;
                })
              }
            </ul>
          </div>
        </div>
      </InView>
    </div>
  );
}